import React from "react"

import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"

const UserEmailAddressViewList = ({ emails, isFetching }) => (
    <div className="margin-top--5">
        {emails && emails.length > 0 ? (
            emails.map((email, index) => <p key={index}>{email}</p>)
        ) : (
            <ContentLoaderLines
                isFetching={isFetching}
                minLines={1}
                maxLines={5}
            >
                <p>No email adress</p>
            </ContentLoaderLines>
        )}
    </div>
)

export default UserEmailAddressViewList
